module.exports = __webpack_public_path__ + "img/img_blank_adress@2x.385659a6.png";